/// <amd-module name="SuiteCommerce.Blog.Post.Content.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Content.View", ["require", "exports", "Backbone", "jQuery", "sc_blog_post_content.tpl", "SuiteCommerce.Blog.Post.Configuration", "SuiteCommerce.Blog.Common", "SuiteCommerce.Blog.Instrumentation"], function (require, exports, Backbone_1, jQuery, contentTemplate, Post_Configuration_1, Common_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostContentView = void 0;
    var PostContentView = /** @class */ (function (_super) {
        __extends(PostContentView, _super);
        function PostContentView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = contentTemplate;
            return _this;
        }
        PostContentView.prototype.getContext = function () {
            return {
                content: this.model.content
                    ? this.getProcessedBlogContent("" + this.model.content)
                    : '',
                notProcessedContent: this.model.content,
            };
        };
        PostContentView.prototype.getProcessedBlogContent = function (blogContent) {
            var blogProcessedContent = blogContent;
            if (!Post_Configuration_1.PostConfiguration.isRunningInSEO()) {
                blogProcessedContent = this.processCMSAreasMarkup(blogProcessedContent);
                if (Post_Configuration_1.PostConfiguration.largeImageResize) {
                    blogProcessedContent = this.resizeImages(blogProcessedContent, Post_Configuration_1.PostConfiguration.largeImageResize.name);
                }
            }
            blogProcessedContent = this.generateCMSAreas(blogProcessedContent);
            this.createQuantityOfCustomCMSAreasLog();
            return blogProcessedContent;
        };
        PostContentView.prototype.processCMSAreasMarkup = function (blogContent) {
            var $htmlNodesModified = jQuery("<div>" + blogContent + "</div>");
            $htmlNodesModified.children().each(function (index, element) {
                var $element = jQuery(element);
                $element.html($element
                    .html()
                    .replace(PostContentView.CMS_AREA_REG, function (substring) {
                    $element.after(substring + " ");
                    return '';
                }));
                $element.wrap('<div data-component="content-wrapper"></div>');
            });
            return $htmlNodesModified.html();
        };
        PostContentView.prototype.resizeImages = function (blogContent, resizeId) {
            var $htmlNodesModified = jQuery("<div>" + blogContent + "</div>");
            var domainUrl = jQuery(location).attr('origin');
            $htmlNodesModified.find('img').each(function (index, element) {
                var $element = jQuery(element);
                var urlAfterCanonicalization = $element.prop('src');
                if (urlAfterCanonicalization.indexOf(domainUrl) !== -1) {
                    $element.attr('src', Common_1.resizeImage($element.attr('src'), resizeId));
                }
            });
            return $htmlNodesModified.html();
        };
        PostContentView.prototype.generateCMSAreas = function (blogContent) {
            return blogContent.replace(PostContentView.CMS_AREA_REG, function (substring) {
                var substringWithoutBrackets = substring
                    .replace('[[', '')
                    .replace(']]', '');
                var contentAreaId = substringWithoutBrackets.split(':')[1];
                return "<div class=\"sc-blog-layout-dynamic-cms-area\"\n                    data-cms-area=\"blog-post-g-" + contentAreaId + "\"\n                    data-cms-area-filters=\"path\"></div>";
            });
        };
        PostContentView.prototype.createQuantityOfCustomCMSAreasLog = function () {
            var log = Instrumentation_1.default.getLog('quantityOfCustomCMSAreasLog');
            log.setParameters({
                activity: 'Custom CMS Areas Usage',
                instanceCount: (this.model.content.match(PostContentView.CMS_AREA_REG) || []).length,
            });
            log.submit();
        };
        PostContentView.CMS_AREA_REG = /\[\[content:[-\w]{1,20}\]\]/g;
        return PostContentView;
    }(Backbone_1.View));
    exports.PostContentView = PostContentView;
});
